import React from 'react';
import { painPoints } from '../data/content';
import { CTAButton } from './CTAButton';
export function PainPoints() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-215" data-mp="2lmspkkrd14js">
      <div className="mx-auto max-w-3xl" data-id="element-216" data-mp="26z7n8t2b79cx">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-217" data-mp="26wbpp5udimp0">
          Do you recognize yourself in any of these?
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-218" data-mp="1xw6iowt3dqbd">
          {painPoints.map(point => <li key={point.text} className="flex items-start gap-4 rounded-xl border border-white/10 bg-navy-900 p-4" data-id="element-219" data-mp="220e6mrrq728j">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-220" data-mp="1syn1bo13kxf7">
                {point.emoji}
              </span>
              <span className="text-sm leading-snug text-slate-200 sm:text-base" data-id="element-221" data-mp="3idbi01gq11j1">{point.text}</span>
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display text-2xl font-700 uppercase text-gold-400 sm:text-3xl" data-id="element-222" data-mp="3nbwfht4l973s">
          You deserve a clearer clinical process
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-223" data-mp="1u0iyn4gcruv1">
          <CTAButton label="Yes, I want the system" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-224" data-mp="1tzr8wa9fsrco" />
        </div>
      </div>
    </section>;
}